import axios from 'axios';
import environment from './environment';

export const instanceAxios = (token = '') => {
  const instance = axios.create({
    baseURL: environment,
  });

  if (token !== '')
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;

  return instance;
};
